import React, { useEffect, useState } from 'react';
import DownloadCastAppModalComponent from '../components/DownloadCastAppModal';
import { parseYmlForDmg, parseYmlForPath } from '../utils/parseYml';


const DownloadCastAppModal = (props) => {
  const [downloadMacIntel, setDownloadMacIntel] = useState('');
  const [downloadWindows64, setDownloadWindows64] = useState('');

  useEffect(() => {
    const fetchLinks = () => {
      const channel = (window.location.host.split('.').reverse()[2] || 'latest').
      replace('app', 'latest');
      const bucket = `https://shootsta-cast-releases-${channel}.s3.ap-southeast-2.amazonaws.com`;
      fetch(`${bucket}/${channel}-mac.yml`, { method: 'GET' }).
      then((res) => res.text() || '').
      then((yml) => setDownloadMacIntel(`${bucket}/${encodeURIComponent(parseYmlForDmg(yml))}`))
      // eslint-disable-next-line no-console
      .catch(console.error);
      fetch(`${bucket}/${channel}.yml`, { method: 'GET' }).
      then((res) => res.text() || '').
      then((yml) => setDownloadWindows64(`${bucket}/${encodeURIComponent(parseYmlForPath(yml))}`))
      // eslint-disable-next-line no-console
      .catch(console.error);
    };
    fetchLinks();
  });

  return (
    <DownloadCastAppModalComponent
      downloadMacIntel={downloadMacIntel}
      downloadWindows64={downloadWindows64}
      {...props} />);


};

export default DownloadCastAppModal;